export const replaceRouteWithReload = url => {
  window.location = url;
};
